import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface UserSelf {
  showUpdateLog?: boolean;
  userVersion?: string;
}

export const setUserSelf = createAction('[UserSelf] Set UserSelf Info', props<Partial<UserSelf>>());
export const mergeUserSelf = createAction('[UserSelf] Merge UserSelf Info', props<Partial<UserSelf>>());
export const resetUserSelf = createAction('[UserSelf] Reset Empty UserSelf');

export function userSelfReducer(pState: UserSelf | undefined, action: Action) {
  return createReducer(
    {},
    on(setUserSelf, (state, UserSelf) => UserSelf),
    on(mergeUserSelf, (state, UserSelf) => merge({}, state, UserSelf)),
    on(resetUserSelf, state => null)
  )(pState, action);
}
